import { translateUi } from "@/shared/lib/ui-translate";
/**
 * Процесс получения информации о пользователе Twitch
 */

import { TwitchAPI, TwitchUser } from "../../api/twitch-api";

export interface FetchUserInfoParams {
  userLogin: string;
}

export interface FetchUserInfoResult {
  status: "ok" | "invalid" | "not_found" | "error";
  user?: TwitchUser;
  error?: string;
}

export async function fetchTwitchUserInfo({
  userLogin,
}: FetchUserInfoParams): Promise<FetchUserInfoResult> {
  try {
    // Валидация параметров
    if (
      !userLogin ||
      typeof userLogin !== "string" ||
      userLogin.trim() === ""
    ) {
      return {
        status: "invalid",
      };
    }

    // Получаем данные от Twitch API
    const user = await TwitchAPI.getUserByLogin(userLogin.trim());

    if (!user) {
      return {
        status: "not_found",
      };
    }

    return {
      status: "ok",
      user,
    };
  } catch (error) {
    return {
      status: "error",
      error: error instanceof Error ? error.message : translateUi("litUseTwitch.oshibkaTwitchApi"),
    };
  }
}
